export default {
  'notFound.title': 'Whoops! Page Not Found',
  'notFound.desc':
    'Whoops! Something went wrong. The page you were looking for was not found.',
  'notFound.toHome': 'Back To Home',
};
